import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RestPartnerService } from '@app/core/api/partner.service';
import { ActivePartnerQuery } from '@app/core/state/active-partner/active-partner.query';
import { ActivePartnerStore } from '@app/core/state/active-partner/active-partner.store';
import { CompareUtil } from '@app/core/util/compare.util';
import { PayloadUtil } from '@app/core/util/payload.util';
import { PayloadPerson, PayloadVertreter, Person } from '@pezi/entities';
import { Subscription, take } from 'rxjs';
import { setProps } from '@ngneat/elf';
import { PersistentTabService } from '../persistent-tab/persistent-tab.service';
import { PersistentTabUtil } from '../persistent-tab/persistent-tab.util';

@Injectable({providedIn: 'root'})
export class ActivePartnerService {

  private subscription: Subscription;

  constructor(private activePartnerStore: ActivePartnerStore,
              private activePartnerQuery: ActivePartnerQuery,
              private partnerService: RestPartnerService,
              private snackBar: MatSnackBar, private tabService: PersistentTabService) {
  }

  initPartner(id: number, version?: number) {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.activePartnerStore.data.update(setProps({
        loading: false
      }));
    }
    const currentState = this.activePartnerStore.data.getValue();
    if (!id) {
      this.clearStore();
    } else {
      if (!currentState.partner || currentState.partner.id !== +id || !CompareUtil.hasSameVersion(version, currentState.partner)) {

        const cachedObs$ = this.tabService.getCachedDataFromTabs<PayloadPerson>('/partner/' + id, version);
        const pObservable = (!version || version === 1) ? this.partnerService.getPartner(id) : this.partnerService.getPartnerVersion(id, version);
        this.activePartnerStore.data.reset();
        this.activePartnerStore.data.update(setProps({
          loading: true
        }));
        this.subscription = (cachedObs$ ? cachedObs$ : pObservable).pipe(
            take(1)
          )
          .subscribe(result => {
            let partner: Person;
            let errorLoadingPartner = false;
            if (PayloadUtil.handlePayloadSnackbarErrorOnly(result, this.snackBar,
              'Fehler: Partner konnte nicht geladen werden')) {
              partner = result.data;
            } else {
              errorLoadingPartner = true;
            }
            this.activePartnerStore.data.update(setProps({
              loading:      false,
              errorLoading: errorLoadingPartner,
              partner
            }));
            this.tabService.addTab({
              config: PersistentTabUtil.getPartnerTabConfig(result.data, version),
              data:   result.data
            });
          });
      }
    }
  }

  clearStore() {
    this.activePartnerStore.data.reset();
  }
}
